module.exports = __webpack_public_path__ + "static/media/function.48d6c64c.png";